import service from "./api/Services/ServiceAPI";
import utility from "./api/Utility/UtilityAPI";
import branch from "./api/Branches/BranchAPI";
import membership from "./api/Membership/MembershipAPI";
import membershipRate from "./api/Membership/MembershipRateAPI";
import membershipBenefit from "./api/Membership/MembershipBenefitAPI";
import miniType from "./api/Branches/TCDCMiniTypeAPI";
import serviceArea from "./api/Services/ServiceAreaAPI";
import venueHire from "./api/Services/VenueHireAPI";
import venueHireDetails from "./api/Services/VenueHireDetailsAPI";
import groupVisit from "./api/Services/GroupVisitAPI";
import travelInfo from "./api/Services/TravelInfoAPI";
import restaurant from "./api/Services/RestaurantAPI";
import TCDCMini from "./api/Branches/TCDCMiniAPI";
import about from "./api/About/aboutAPI";
import network from "./api/About/NetworkAPI";
import menu from "./api/Menu/MenuAPI";
import subMenu from "./api/Menu/SubMenuAPI";
import floor from "./api/Services/FloorAPI";
import members from "./api/Membership/MembersAPI";
import location from "./api/About/LocationAPI";
import ResourceCenter from "./api/ResourceCenter/ResourceCenterAPI";
import onlineExhibition from "./api/ResourceCenter/OnlineExhibitionAPI";
import news from "./api/About/NewsAPI";
import partner from "./api/About/PartnerAPI";
import sponserProgram from "./api/About/SponserProgramAPI";
import Contact from "./api/About/ContactAPI";
import DesignWorldCalendar from "./api/DesignWorldCalendar/DesignWorldCalendarAPI";
import Faq from "./api/Faq/FaqAPI";
import FaqCategory from "./api/Faq/FaqCategoryAPI";
import Banner from "./api/Banner/BannerAPI";
import LandingPage from "./api/LandingPage/LandingPageAPI";
import Auth from './api/Utility/Auth';
import CustomerSupport from "./api/CustomerSupport/customerSupportAPI";
export default {
  ServiceAPI : service,
  UtilityAPI : utility,
  BranchAPI : branch,
  MembershipAPI : membership,
  MembershipRateAPI : membershipRate,
  MembershipBenefitAPI : membershipBenefit,
  TCDCMiniTypeAPI : miniType,
  ServiceAreaAPI : serviceArea,
  VenueHireAPI : venueHire,
  VenueHireDetailsAPI : venueHireDetails,
  GroupVisitAPI : groupVisit,
  TravelInfoAPI : travelInfo,
  RestaurantAPI : restaurant,
  TCDCMiniAPI : TCDCMini,
  AboutAPI : about,
  NetworkAPI : network,
  MenuAPI : menu,
  SubMenuAPI : subMenu,
  FloorAPI : floor,
  MembersAPI : members,
  LocationAPI : location,
  ResourceCenterAPI : ResourceCenter,
  OnlineExhibitionAPI : onlineExhibition,
  NewsAPI : news,
  PartnerAPI : partner,
  SponserProgramAPI : sponserProgram,
  ContactAPI : Contact,
  DesignWorldCalendarAPI : DesignWorldCalendar,
  FaqAPI : Faq,
  FaqCategoryAPI : FaqCategory,
  BannerAPI : Banner,
  LandingPageAPI : LandingPage,
  AuthAPI : Auth,
  CustomerSupportAPI : CustomerSupport
}
